import * as React from "react";
import {Component} from "react";
import {Button, Icon} from "bloomer";
import {
    AudioContainer,
    DownloadButtonContainer,
    ErrorMessage,
    InformationCard
} from "../../../../../components/model/TextToSpeech/TextToSpeechStyledComponents";
import Spacer from "../../../../../elements/Spacer";

interface ITextToSpeechModelInputState {
    result: any;
    autoPlay: boolean;
    errorMessage: string;
}

class TextToSpeechModelOutput extends Component<{}, ITextToSpeechModelInputState> {
    public emptyOption: any = {
        id: "",
        name: "-"
    };
    public genderOptions: any[] = [this.emptyOption, {
        id: "male",
        name: "Male"
    }, {
        id: "female",
        name: "Female"
    }];
    public audioStyle = {width: '100%'};

    public constructor(props: {}) {
        super(props);

        this.state = {
            result: null,
            autoPlay: false,
            errorMessage: ""
        };
    }

    public processResponse = (blob: any) => {
        if (blob) {
            this.setState({
                result: {
                    blob,
                    src: URL.createObjectURL(blob),
                    type: blob.type
                }
            });
        } else {
            this.setState({
                errorMessage: "Unable to get audio."
            });
        }
    };

    public setMetaData = (metaData: any) => {
        if (metaData) {
            this.setState({
                autoPlay: metaData.autoPlay
            });
        }
    };

    public downloadResultAsFile = (e: any) => {
        e.target.blur();

        if (this.state.result) {
            const element = document.createElement("a");
            element.href = this.state.result.src;
            element.download = "result.mp3";
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
        }
    }

    public render() {
        return <React.Fragment>
            {
                this.state.result ? <div>
                    <Spacer/>
                    <Spacer/>
                    <InformationCard>
                        <AudioContainer>
                            <audio
                                style={this.audioStyle}
                                controls={true}
                                autoPlay={this.state.autoPlay}
                            >
                                <source
                                    src={this.state.result.src}
                                    type={this.state.result.type}
                                />
                            </audio>
                        </AudioContainer>
                        <DownloadButtonContainer>
                            <Button onClick={this.downloadResultAsFile} title="Download as .mp3 file">
                                <Icon className="far fa-file-alt" style={{marginRight: '5px'}}/>Download
                            </Button>
                        </DownloadButtonContainer>
                    </InformationCard>
                </div> : <></>
            }
            {
                this.state.errorMessage && <ErrorMessage>{this.state.errorMessage}</ErrorMessage>
            }
        </React.Fragment>;
    }
}

export default TextToSpeechModelOutput;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/CrossProvider/output/TextToSpeech/TextToSpeechModelOutput.tsx